import { gsap } from 'gsap';

export class CommonAnimations{

    static transitMovement(target:PIXI.DisplayObject, durr:number, goAway:boolean, dirrY:number = 200){
        return gsap.fromTo(target,
            { alpha: goAway ? 1 : 0 },
            { alpha: goAway ? 0 : 1,
            y: goAway ? "-=" + dirrY : "+=" + dirrY , duration: durr, ease: "Back.easeIn.config(1.25)" });
    }
}